import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from './Icons';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onToggle
}: FAQItemProps) {
  return <div className="border-b border-gold/15 last:border-b-0" data-id="element-186">
      <button onClick={onToggle} className="w-full flex items-center justify-between py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 rounded-lg" aria-expanded={isOpen} data-id="element-187">
        <span className="font-body text-base md:text-lg font-semibold text-brown-dark pr-4" data-id="element-188">
          {question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.25,
        ease: 'easeInOut'
      }} className="flex-shrink-0" data-id="element-189">
          <ChevronDownIcon className="w-5 h-5 text-gold" data-id="element-190" />
        </motion.div>
      </button>
      <AnimatePresence initial={false} data-id="element-191">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-192">
            <p className="font-body text-base text-warm-gray leading-relaxed pb-5 pr-10" data-id="element-193">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full bg-beige py-10 md:py-24 px-5" data-id="element-194">
      <div className="max-w-2xl mx-auto" data-id="element-195">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="font-heading text-2xl md:text-3xl font-bold text-brown-dark text-center mb-7 md:mb-12" data-id="element-196">
          Preguntas Frecuentes
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="bg-white-soft rounded-xl p-6 md:p-8 border border-gold/15" data-id="element-197">
          <FAQItem question="¿Sirve si tengo el pelo teñido?" answer="Sí, el protocolo restaura el pH que el tinte altera. De hecho, muchas mujeres notan que su tinte dura más tiempo después de equilibrar el cuero cabelludo." isOpen={openIndex === 0} onToggle={() => handleToggle(0)} data-id="element-198" />
          <FAQItem question="¿Es difícil de hacer?" answer="No, toma menos de 10 minutos al día con ingredientes que ya tienes en casa. Las instrucciones son claras y paso a paso." isOpen={openIndex === 1} onToggle={() => handleToggle(1)} data-id="element-199" />
          <FAQItem question="¿Tengo que dejar mis otros productos?" answer="Solo los que tengan sulfatos agresivos; te enseñamos cuáles son. El resto de tu rutina puede continuar normalmente." isOpen={openIndex === 2} onToggle={() => handleToggle(2)} data-id="element-200" />
          <FAQItem question="¿Cuándo veré pelo nuevo?" answer="Primero detendremos la caída. El crecimiento nuevo se nota entre 4 y 8 semanas, dependiendo de tu caso particular y la constancia con el protocolo." isOpen={openIndex === 3} onToggle={() => handleToggle(3)} data-id="element-201" />
        </motion.div>
      </div>
    </section>;
}